import { css } from 'styled-components';
import PropTypes from 'prop-types';
import makeThemedComponent from '../../utils/makeThemedComponent';
import { defaultStyles as buttonStyles } from '../Button'; // css returns an array for use in other template literals

var defaultStyles = buttonStyles.concat(css(["height:", ";width:", ";border-radius:50%;"], function (props) {
  return props.diameter;
}, function (props) {
  return props.diameter;
}));
/**
 * Renders a circular `button` element. Note that `Button` theme styles will not
 * be applied to `CircularButton` and must be added under the `CircularButton`
 * theme key.
 *
 * @public
 * @author Connor Taylor
 */

var CircularButton = makeThemedComponent({
  themeKey: "CircularButton",
  component: "button",
  defaultStyles: defaultStyles
});
CircularButton.defaultProps = {
  diameter: "100px"
};
CircularButton.propTypes = {
  /** How big the CircularButton should be */
  diameter: PropTypes.string
};
export { defaultStyles };
/** @component */

export default CircularButton;